import get from '../helpers/get';

export const isGuestAccount = state => get(state, ['account', 'details', 'isGuest']) !== false;
export const getEveApiAccessToken = state => get(state, ['account', 'token', 'access_token']);
